import { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import AIChatPanel from './AIChatPanel';

/**
 * Admin Ops Copilot launcher — button that opens the AI chat panel.
 * Uses Gemini 3.1 Pro on the backend with live platform data as context.
 */
export default function AICopilotLauncher() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setOpen(true)}
        className="text-orange-600 border-orange-300 hover:bg-orange-50"
        data-testid="ai-copilot-launcher"
      >
        <Sparkles className="w-4 h-4 mr-1" />
        Ops Copilot
      </Button>
      <AIChatPanel
        open={open}
        onClose={() => setOpen(false)}
        endpoint="/ai/admin/copilot"
        title="Ops Copilot"
        subtitle="Live data · Gemini 3.1 Pro"
        colorClass="from-zinc-800 to-zinc-900"
        testIdPrefix="ai-copilot"
        starterPrompts={[
          "What's my busiest hub this week?",
          'Summarize this week in 2 sentences',
          'Draft a broadcast about the July 4th surge',
          'How many open disputes do I have?',
        ]}
      />
    </>
  );
}
